import Grid from '@material-ui/core/Grid';
import React, { useEffect, memo } from 'react';
import { toast } from 'react-toastify';
import { Space } from 'v2/components/Shared/Space';
import affiliationsService from 'v2/services/affiliations';

import { List } from './List';
import styles from './styles';

const Affiliations = () => {
  const classes = styles({});

  useEffect(() => {
    affiliationsService.loadAffiliations().subscribe(() => {}, toast.error);
  }, []);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.title}>
            <h1>Minhas Afiliações</h1>
            <p>Gerencie suas afiliações.</p>
          </div>
        </Grid>
      </Grid>

      <Space axis='vertical' size={16} />

      <List />
    </>
  );
};

export default memo(Affiliations);
